import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Button,Table } from 'reactstrap';
import ReactDOM from 'react-dom';
import IframeResizer from 'iframe-resizer-react';
import Iframe from 'react-iframe';
import moment from 'moment';
//There are a number of iframe imports here that wound up never being used. They might be useful for another component later, so I'm keeping them in my back pocket here.

export class FormsDashboard extends Component {
    static displayName = FormsDashboard.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            formURL: "",
            formName: "",
            showForm: false,
            fullFormList: [",","."]
        }
        this.getData();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data,
            loading: false,
            username: data.username,
        });
        this.setState({
            level: this.props.ourLevel
        });
        //var dept = this.state.returnable.level
        //this.recordComingHere();
        this.testPermission();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1031",
    //        department: this.state.returnable.level,
    //        userPCID: this.state.returnable.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.state.returnable.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    this.getFormList();
    //}

    async testPermission() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: "1031"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    async getFormList() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetMyForms', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            fullFormList: data
        })
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src = "//tfaforms.com/js/iframe_resize_helper.js";
        script.async = true;
        document.body.appendChild(script);
    }

    iframeDiv() {
        return (
            <div>
                <Button onClick={() => this.hideForm()}>Close</Button>
                <iframe src={this.state.formURL} title={this.state.formName} height="800" width="100%" />
                </div>
        )
        
    }

    hideForm() {
        this.setState({
            showForm: false
        })
    }

    linkList() {
        return (
            <div>
                <Table borderless>
                    <tbody>
                    {this.state.fullFormList.map(formItem => (
                        <tr>
                            <td><a className="lookLikeLink" onClick={() => this.showForm(formItem.formurl, formItem.formname)}>{formItem.formname}</a></td>
                            <td><a className="lookLikeLink" onClick={() => this.showForm(formItem.workflowurl, formItem.workflowname)}>{formItem.workflowname}</a></td>
                            <td>{formItem.formstatus}</td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
            )
    }

    showForm(id, name) {
        this.setState({
            formURL: id,
            formName: name,
            showForm: true
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
        let pageDisplay = this.linkList();//Usually pageDisplay would be initialized as a blank div and then conditionally assigned a value, but we always want to start it out in the list view here
        if (this.state.showForm == true) { pageDisplay = this.iframeDiv(); }
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            {pageDisplay}
                        </div>
                    )}
                </UserContext.Consumer>
            );
        
    }
}